import { render } from "./ReferralContacts.vue?vue&type=template&id=296b6302&ts=true"
import script from "./ReferralContacts.vue?vue&type=script&lang=ts"
export * from "./ReferralContacts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__